export default "/images/12860c5c38b6d7d4104ef3767be13ed3.png";